import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  firstname: "",
  lastname: "",
  username: "",
  email: "",
  phone: "",
  is2FA: false,
  isPasswordResetRequired: false,
  occupiedFunction: "",
  token: null,
  roles: null,
  lang: null,
  restaurants: [],
  restaurantId: null,
  originalRestaurantId: null,
  companyId: null,
  originalCompanyId: null,
  imagePath: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userId = action.payload.userId;
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.phone = action.payload.phone;
      state.is2FA = action.payload.is2FA;
      state.isPasswordResetRequired = action.payload.isPasswordResetRequired;
      state.occupiedFunction = action.payload.occupiedFunction;
      state.roles = action.payload.roles;
      state.lang = action.payload.language;
      state.imagePath = action.payload.fullImagePath;
      state.restaurants = action.payload.restaurants;
      state.restaurantId =
        action.payload.restaurants.length === 1
          ? action.payload.restaurants[0].restaurantId
          : null;
      state.originalRestaurantId = action.payload.restaurantId;
      const companyId = action.payload.companies
        ? action.payload.companies.find(
            (company) => company.usercompany?.isMain
          )?.companyId
        : null;
      state.companyId = companyId;
      state.originalCompanyId = companyId;
      state.token = action.payload.token;
      state.apiKey = action.payload.apiKey;
    },
    updateUser: (state, action) => {
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.occupiedFunction = action.payload.occupiedFunction;
      state.lang = action.payload.language;
      state.is2FA = action.payload.is2FA;
      state.isPasswordResetRequired = action.payload.isPasswordResetRequired;
      state.imagePath = action.payload.fullImagePath;
    },
    updateLang: (state, action) => {
      state.lang = action.payload;
    },
    updateRestaurantValues: (state, action) => {
      state.restaurants.find(
        (r) => r.restaurantId === state.restaurantId
      ).consumptionmodes = action.payload.consumptionmodes;
      if (action.payload.fullImagePath)
        state.restaurants.find(
          (r) => r.restaurantId === state.restaurantId
        ).images[0].fullImagePath = action.payload.fullImagePath;
    },
    updateRestaurantSubscriptions: (state, action) => {
      const { restaurantId, subscriptions } = action.payload;
      const restaurant = state.restaurants.find(
        (r) => r.restaurantId === restaurantId
      );
      if (restaurant) {
        restaurant.subscriptions = subscriptions;
      }
    },
    updateApiKey: (state, action) => {
      state.apiKey = action.payload;
    },
    clearUser: () => initialState,
    setUserRestaurants: (state, action) => {
      state.restaurants = action.payload;
    },
    setRestaurantId: (state, action) => {
      state.restaurantId = action.payload;
    },
    restoreRestaurantId: (state) => {
      state.restaurantId = state.originalRestaurantId;
    },
    setCompanyId: (state, action) => {
      state.companyId = action.payload;
    },
    setIsPasswordResetRequired: (state, action) => {
      state.isPasswordResetRequired = action.payload;
    },
    restoreCompanyId: (state) => {
      state.companyId = state.originalCompanyId;
    },
  },
});

export const {
  setUser,
  updateUser,
  updateLang,
  updateRestaurantValues,
  updateRestaurantSubscriptions,
  updateApiKey,
  clearUser,
  setUserRestaurants,
  setRestaurantId,
  setIsPasswordResetRequired,
  restoreRestaurantId,
  setCompanyId,
  restoreCompanyId,
} = userSlice.actions;

export default userSlice.reducer;
